import { useContext } from 'react';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { Tabs } from 'antd';
import { styled } from 'styled-components';

const TabsStyles = styled.div`
  /* 点Table组件的样式 */
  .ant-tabs .ant-tabs-tab:hover {
    color: #0093e6 !important;
  }
  .ant-tabs .ant-tabs-ink-bar {
    background: #0093e6 !important;
  }
`;

export default function ItemTab({ itemTabList }) {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;
  const ListPage = ({ list, parentIdx }) => {
    return (
      <>
        <ul className="flex flex-wrap ">
          {list?.map((item, idx) => (
            <li
              key={idx}
              className={`w-[165px] lc-text-hidden text-left text-[#000000] text-[12px] mb-[20px] cursor-pointer hover:text-[#0093E6]`}
            >
              <a
                href={`${projectConfigVO?.lcscItemUrl}/${item?.productId}.html`}
                target="_blank"
                title={item.productModel}
                data-spm={parentIdx + '-' + (idx + 1)}
                aria-label={`查看元器件${item.productModel}详情`}
              >
                {item.productModel}
              </a>
            </li>
          ))}
        </ul>
      </>
    );
  };
  const tabTitleList = [];
  Object.keys(itemTabList).forEach((val) => {
    if (val === 'similarProductList' && itemTabList[val]?.length > 0) {
      tabTitleList.push({
        key: 'similarProductList',
        label: '相似推荐',
        children: <ListPage list={itemTabList?.['similarProductList']} parentIdx="1" />,
      });
    }
    if (val === 'otherProductList' && itemTabList[val]?.length > 0) {
      tabTitleList.push({
        key: 'otherProductList',
        label: '其他推荐',
        children: <ListPage list={itemTabList?.['otherProductList']} parentIdx="2" />,
      });
    }
  });

  return (
    <section
      className="mt-[20px] mx-auto bg-[#ffff] w-[1200px] rounded-[20px] p-[20px] pt-[8px] pb-[0] [content-visibility:auto] [contain-intrinsic-height:186px]"
      data-spm="tj"
    >
      <TabsStyles>
        <Tabs defaultActiveKey={tabTitleList[0]?.key}>
          {tabTitleList.map((item) => (
            <Tabs.TabPane key={item.key} tab={item.label} forceRender>
              {item.children}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </TabsStyles>
    </section>
  );
}
